import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Upload,
  Icon,
  Tooltip,
} from 'antd';
import styles from './style.less';
import { s3Host } from "../../../../utils";

class ImagesField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ fileList: nextProps.formData });
  }

  setMain = (file) => {
    this.setState(({ fileList }) => {
      fileList.forEach((item) => {
        if (file.uid === item.uid) { item.is_main = true; } else item.is_main = false;
      });

      this.props.onChange(fileList);
      return {
        fileList,
      };
    });
  }

  handleRemove = (file) => {
    this.setState(({ fileList }) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      this.props.onChange(newFileList);
      return {
        fileList: newFileList,
      };
    });
  }

  handleChange = (info) => {
    let { fileList } = info;
    // 2. read from response and show file link
    fileList = fileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.link = file.response.data.link;
      }
      return file;
    });

    if (fileList.length === 1) {
      fileList[0].is_main = true;
    }

    this.setState({ fileList }, this.props.onChange(fileList));
  }

  render() {
    const { fileList } = this.state;
    const options = {
      action: '/rest/store_product/upload_image',
      multiple: true,
      accept: 'image/*',
      listType: 'picture-card',
      showUploadList: false,
      onChange: this.handleChange,
    };

    return (
      <div className={styles.satUploader1}>
        <div className="ant-upload-list ant-upload-list-picture-card">
          {
            fileList.map((item, index) => (
              <div key={item.uid || index} className={`ant-upload-list-item ${item.is_main ? styles.main : ''}`}>
                <div className="ant-upload-list-item-info">
                  { (item.status === 'done' || item.link) ?
                    <span>
                      <a className="ant-upload-list-item-thumbnail">
                        <img src={`${s3Host}${item.link}`} alt="" />
                      </a>
                    </span>
                      :
                    <span>
                        Хуулж байна...
                    </span>
                  }
                </div>
                <span className="ant-upload-list-item-actions">
                  <Tooltip title="Үндсэн зураг болгох" onClick={() => this.setMain(item)}>
                    <i className="anticon anticon-eye-o" />
                  </Tooltip>
                  <Tooltip title="Устгах">
                    <Icon type="trash" className="anticon-delete" onClick={() => this.handleRemove(item)} />
                  </Tooltip>
                </span>
              </div>
            ))
          }
          <Upload {...options} fileList={fileList}>
            <p className="ant-upload-drag-icon">
              <Icon type="plus" />
            </p>
          </Upload>
        </div>

      </div>
    );
  }
}

ImagesField.defaultProps = {
  formData: [],
};

ImagesField.propTypes = {
  formData: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default ImagesField;



// WEBPACK FOOTER //
// ./src/components/Form/FieldTemplates/ImagesFieldTemplate/index.js